module.exports = __webpack_public_path__ + "img/Cathal_Gurrin@2x.5fafa758.png";